import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentCancelPage = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="min-h-screen bg-misel-bg flex items-center justify-center p-8">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="text-center max-w-md"
      >
        <XCircle size={64} className="text-yellow-500 mx-auto mb-6" />
        <h1 className="font-roboto font-bold text-2xl text-white mb-4">
          {t('payment.cancelled')}
        </h1>
        <p className="text-gray-400 mb-8">
          {i18n.language === 'el'
            ? 'Η πληρωμή ακυρώθηκε. Δεν έχει χρεωθεί τίποτα στο λογαριασμό σας.'
            : 'The payment was cancelled. Nothing was charged to your account.'
          }
        </p>
        <div className="flex flex-col gap-4">
          <Link to="/pricing">
            <Button className="w-full bg-primary hover:bg-primary/90">
              {i18n.language === 'el' ? 'Δες τα πλάνα' : 'View Plans'}
            </Button>
          </Link>
          <Link to="/">
            <Button variant="outline" className="w-full border-white/20 text-white hover:bg-white/10">
              {t('payment.back_home')}
            </Button>
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default PaymentCancelPage;
